export class CountryModel {
    public CountryCode: string;
    public CountryName: string;
}

